import {useCallback} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {prependBackendUrl} from '../gql/client'
import {useGetUser} from '../store/userStore'

/**
 * CID del logo que el backend adjunta al enviar el correo.
 *
 * Las plantillas de email lo referencian como `<img src="cid:logo_cid">` y al
 * enviar el backend adjunta la imagen inline (ver `resolve_logo` en
 * core/services/email.py). Es el mismo mecanismo de los correos de notificación
 * del sistema.
 */
export const EMAIL_LOGO_CID = 'cid:logo_cid'

/** Logo de la app, para cuando la organización no tiene ninguno cargado. */
export const FALLBACK_PREVIEW_LOGO = '/media/tfi/logo_policytools.png'

/**
 * Devuelve una función que sustituye el `cid:` por el logo de la organización.
 *
 * Se usa **Organization Logo** y no **Template Logo**: el primero es el logo a
 * color (el mismo que resuelve `{{agent_logo}}` en los formularios de firma) y
 * el correo se lee sobre fondo blanco. El Template Logo alimenta el sidebar, que
 * es oscuro, así que suele ser la versión en blanco: sobre el correo sería
 * invisible. Mismo orden que el backend al adjuntar la imagen.
 */
export const useEmailPreviewLogo = () => {
  const currentUser = useGetUser((s) => s.user?.user)
  const organization = currentUser?.organization
  const logoUrl =
    (organization?.logo && prependBackendUrl(organization.logo)) ||
    (organization?.templateLogo && prependBackendUrl(organization.templateLogo)) ||
    (currentUser?.organizationTemplateLogo &&
      prependBackendUrl(currentUser.organizationTemplateLogo)) ||
    toAbsoluteUrl(FALLBACK_PREVIEW_LOGO)

  return useCallback(
    (html: string): string => html.split(EMAIL_LOGO_CID).join(logoUrl),
    [logoUrl]
  )
}
